import { useGroupGuid } from 'components/IAP/hooks/commonHooks';
import { useListExternalLayersQuery } from 'hooks/externalLayer/useListExternalLayersQuery';

/**
 * The workspace's secured (userAuth) external ArcGIS layers. Shared by the Map
 * Layers chat picker and the chat send path so both hit one cached query: the
 * send path needs each secured layer's service URL to find the user's ArcGIS
 * credential, and cannot rely on the picker selection carrying it — selections
 * restored from chat history only hold {kind, id, name}.
 *
 * Deliberately not filtered by incident: the API's incident filter excludes
 * Command Center layers (no incident), which the assistant's layer tools do
 * search. Callers narrow to the current workspace themselves.
 */
export const useSecuredExternalLayers = (options?: { enabled?: boolean }) => {
  const groupGuid = useGroupGuid();

  return useListExternalLayersQuery(
    {
      filter: {
        authType: 'userAuth',
        groupGuid: groupGuid ?? '',
      },
      perPage: 200,
    },
    options
  );
};
